<template>
    <el-dialog
      :visible.sync="dialogVisibleA"
      width="52%"
      @close="handleClose"
      >
      <div class="US_content">
        <div class="left">
          <img class="company_logo" src="../../static/image/Bottom/logo2.png" />
          <img class="code" src="../../static/image/HellowWorld/erweima.jpg" />
          <h5>{{ $t('lang.HellowWorld.wxsm1') }}</h5>
          <p>{{ $t('lang.HellowWorld.yljr') }}</p>
        </div>
        <div class="right">
          <div class="person_info" v-if="!submitFlag">
            <h1>{{ $t('lang.HellowWorld.popup1') }}</h1>
            <p>{{ $t('lang.HellowWorld.popup2') }}</p>
            <el-form :model="personForm">
              <el-form-item :label="$t('lang.HellowWorld.popup3')">
                <img src="../../static/image/HellowWorld/name_img.png" />
                <el-input v-model="personForm.customerName" :placeholder="$t('lang.HellowWorld.popup4')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('lang.HellowWorld.popup5')" prop="email">
                <img src="../../static/image/HellowWorld/email_img.png" />
                <el-input v-model="personForm.email" :placeholder="$t('lang.HellowWorld.popup6')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('lang.HellowWorld.popup7')" prop="phone">
                <img src="../../static/image/HellowWorld/phone_img.png" />
                <el-input type="number" v-model="personForm.phone" :placeholder="$t('lang.HellowWorld.popup8')"></el-input>
              </el-form-item>
              <el-button class="submit" @click="submitInfo">{{ $t('lang.HellowWorld.popup9') }}</el-button>
            </el-form>
          </div>
          <div class="success" v-else>
            <img src="../../static/image/HellowWorld/jiaoyan.png" />
            <h1>提交成功！</h1>
            <p>感谢您的提交！稍后我们将会联系您</p>
          </div>
        </div>
      </div>
    </el-dialog>
</template>

<script>
import { contactUs } from '../api/index.js'
import { Message } from 'element-ui'

export default {
  name: 'ContactUS',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      personForm: {
        customerName: '',
        email: '',
        phone: ''
      },
      dialogVisibleA: false,
      submitFlag: false
    }
  },
  watch: {
    submitFlag (newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          this.dialogVisibleA = false
          this.submitFlag = false
        }, 2000)
      }
    },
    dialogVisible (oldVal, newVal) {
      this.dialogVisibleA = this.dialogVisible
    }
  },
  methods: {
    handleClose () {
      this.$emit('changeShow', 'false')
    },
    async submitInfo () {
      if (!this.personForm.email && !this.personForm.phone) {
        return
      }
      try {
        let params = {
          companyName: '',
          customerName: this.personForm.customerName,
          email: this.personForm.email,
          phone: this.personForm.phone
        }
        let res = await contactUs(params)
        if (res) {
          this.personForm.customerName = ''
          this.personForm.email = ''
          this.personForm.phone = ''
          this.submitFlag = true
        }
      } catch (error) {
        Message.error(error)
      }
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog__headerbtn{
  width: 25px;
  height: 25px;
  border-radius: 50%;
  font-size: 4px;
  line-height: 25px;
  border: 1px solid #909399;
}
/deep/ .el-dialog__header{
  padding: 0;
}
/deep/ .el-dialog__body{
  padding: 0;
  text-align: left;
}
/deep/ .el-form{
  margin-top: 20px;
}
/deep/ .el-form-item__content{
  position: relative;
}
/deep/ .el-form-item__label{
  margin-left: 24px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}
/deep/ .el-input__inner{
  background-color: #FAFAFA;
  border: none;
}
.US_content{
  width: 100%;
  display: flex;
}
.US_content .left{
  width: 520px;
  background: url("./static/image/HellowWorld/popup.png") no-repeat;
  background-size: 100% 101%;
}
.US_content .left .company_logo{
  width: 152px;
  height: 32px;
  margin: 71px 0 0 75px;
}
.US_content .left .code{
  display: block;
  margin: 120px 0 0 183px;
  width: 154px;
  height: 154px;
}
.US_content .left h5{
  margin-top: 24px;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.US_content .left p{
  margin-top: 123px;
  font-size: 14px !important;
  font-weight: 400;
  letter-spacing: 8px;
  color: #fff;
  text-align: center !important;
  width: 100% !important;
}
.US_content .right{
  width: 537px;
}
.US_content .right .person_info{
  padding: 0 90px 0 107px;
  text-align: left;
}
.US_content .right .person_info h1{
  margin-top: 60px;
  font-size: 32px;
  font-weight: 500;
  color: #01286B;
}
.US_content .right .person_info p{
  margin-top: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #8D97A8;
}
/deep/ .US_content .right .person_info .el-form{
  padding-bottom: 62px;
}
.US_content .right .person_info .submit{
  margin: 20px 0 0 80px;
  width: 144px;
  height: 39px;
  color: #fff;
  border-radius: 4px;
  background: #001E3A;
  line-height: 39px;
  padding: 0 !important;
}
.US_content .right .person_info img{
  position: absolute;
  top: 13px;
  width: 16px;
  height: 16px;
}
.success{
  padding-bottom: 299px;
  text-align: center;
}
.success img{
  margin-top: 120px;
  width: 80px;
  height: 80px;
}
.success h1{
  margin-top: 21px;
  font-size: 32px;
  font-weight: 400;
  color: #001E3A;
}
.success p{
  margin-top: 11px;
  font-size: 16px;
  font-weight: 400;
  color: #8D97A8;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactUs.vue